import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchShipments } from '../services/shipments';
import { ListChecks, ArrowRight } from 'lucide-react';

export default function DocumentChecklist() {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchShipments()
      .then((data) => setShipments(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, []);

  const shipmentList = Array.isArray(shipments) ? shipments : [];

  return (
    <div className="space-y-6" data-testid="checklist-page">
      <div className="rounded-xl border border-white/10 bg-navy-900 p-6">
        <div className="flex items-start gap-4">
          <div className="h-10 w-10 rounded-lg bg-cyan-glow/10 border border-cyan-glow/20 grid place-items-center text-cyan-glow shrink-0">
            <ListChecks className="h-5 w-5" />
          </div>
          <div>
            <h2 className="font-display text-xl font-bold tracking-tight">Document checklists by shipment</h2>
            <p className="text-sm text-slate-400 mt-1">Each shipment has a route- and product-aware document checklist. Open a shipment to view and update its checklist.</p>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-white/10 bg-navy-900 overflow-hidden">
        {loading ? (
          <div className="p-8 text-sm text-slate-400">Loading…</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-navy-800/50 border-b border-white/5">
              <tr className="text-left text-xs text-slate-400 uppercase tracking-wider font-mono">
                <th className="px-5 py-3">Reference</th>
                <th className="px-5 py-3">Product</th>
                <th className="px-5 py-3">Route</th>
                <th className="px-5 py-3">Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {shipmentList.map(s => (
                <tr key={s.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]">
                  <td className="px-5 py-3 font-mono text-xs">{s.reference}</td>
                  <td className="px-5 py-3">{s.product_name}</td>
                  <td className="px-5 py-3 text-slate-400">{s.origin_country} → {s.destination_country}</td>
                  <td className="px-5 py-3 capitalize">{s.status}</td>
                  <td className="px-5 py-3 text-right">
                    <Link to={`/shipments/${s.id}?tab=documents`} className="text-cyan-glow hover:text-cyan-hover text-xs inline-flex items-center gap-1" data-testid={`open-checklist-${s.reference}`}>
                      Open checklist <ArrowRight className="h-3 w-3" />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
